<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div>
    <a-form class="login-form">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="帐号"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ updeUserInfo.account || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="创建时间"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ updeUserInfo.createTime || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="帐号状态"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-tag v-if="updeUserInfo.auditStatus == 1" color="orange">
              未提审
            </a-tag>
            <a-tag v-if="updeUserInfo.auditStatus == 2" color="blue">
              审核中
            </a-tag>
            <a-tag v-if="updeUserInfo.auditStatus == 3" color="green">
              正常
            </a-tag>
            <a-tag v-if="updeUserInfo.auditStatus == 4" color="red">
              审核不通过
            </a-tag>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="updeUserInfo.auditStatus == 4">
          <a-form-item
            class="mb-5"
            label="审核不通过理由"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>{{ remark || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="营业执照"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-upload
              :before-upload="beforeUpload"
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              action=""
              :disabled="
                updeUserInfo.auditStatus != 1 && updeUserInfo.auditStatus != 4
              "
              @change="handleChange"
            >
              <img
                style="height: 120px"
                v-if="businessLicense"
                :src="businessLicense"
                alt="avatar"
              />
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">点击上传</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="统一社会信用码/注册号/组织机构代码"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              v-if="
                updeUserInfo.auditStatus == 1 || updeUserInfo.auditStatus == 4
              "
              v-model="creditCode"
              placeholder="请输入统一社会信用码/注册号/组织机构代码"
            />
            <div v-else>{{ creditCode || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="公司名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              v-if="
                updeUserInfo.auditStatus == 1 || updeUserInfo.auditStatus == 4
              "
              v-model="companyName"
              placeholder="请输入公司名称"
            />
            <div v-else>{{ companyName || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="法人名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              v-if="
                updeUserInfo.auditStatus == 1 || updeUserInfo.auditStatus == 4
              "
              v-model="legalName"
              placeholder="请输入法人名称"
            />
            <div v-else>{{ legalName || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="法人身份证"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              v-if="
                updeUserInfo.auditStatus == 1 || updeUserInfo.auditStatus == 4
              "
              v-model="legalCardNumber"
              placeholder="请输入法人身份证"
            />
            <div v-else>{{ legalCardNumber || "--" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            class="mb-5"
            label="公司地址"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-textarea
              v-if="
                updeUserInfo.auditStatus == 1 || updeUserInfo.auditStatus == 4
              "
              v-model="companyAddress"
              placeholder="请输入公司地址"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
            <div v-else>{{ companyAddress || "--" }}</div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item
        v-if="updeUserInfo.auditStatus == 1 || updeUserInfo.auditStatus == 4"
        style="display: flex; justify-content: center"
      >
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import {
  getUserAuditStatus,
  uploadDynamicReturnUrl,
  agentAdd,
} from "@/api/user";
const formItemLayout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};
const formTailLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 8, offset: 4 },
};
export default {
  data() {
    return {
      visible: false,
      updeUserInfo: {},
      stepStatus: "process",
      current: 0,
      checkNick: false,
      formItemLayout,
      formTailLayout,
      loading: false,
      creditCode: "",
      companyName: "", //公司名称
      legalName: "", //
      legalCardNumber: "",
      companyAddress: "",
      businessLicense: "",
      remark: "",
    };
  },
  created() {
    this.updeUserInfo = localStorage.getItem("userInfo");
    this.getUserAuditStatus();
  },
  methods: {
    getUserAuditStatus() {
      if (!this.updeUserInfo.companyId) {
        return;
      }
      getUserAuditStatus({ id: this.updeUserInfo.companyId }).then((res) => {
        if (this.updeUserInfo.auditStatus == 4) {
          this.steps[2] = {
            title: "审核不通过",
            content: "",
          };
          this.stepStatus = "error";
        } else {
          this.stepStatus = "process";
        }
        this.current =
          this.updeUserInfo.auditStatus == 1
            ? 0
            : this.updeUserInfo.auditStatus == 2
            ? 1
            : 2;

        this.creditCode = res.creditCode;
        this.companyName = res.companyName;
        this.legalName = res.legalName;
        this.legalCardNumber = res.legalCardNumber;
        this.companyAddress = res.companyAddress;
        this.businessLicense = res.businessLicense;
        this.remark = res.remark;
      });
    },

    handleChange(info) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", info.file);

      uploadDynamicReturnUrl(formData)
        .then((res) => {
          this.loading = false;
          this.businessLicense = res;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  color: #fff !important;
}
</style>

<style lang="scss" scoped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
  border-radius: 10px !important;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
